// extracted by mini-css-extract-plugin
module.exports = {"featuresPanel":"feapnl-module--featuresPanel--2FtpO","seprateItem":"feapnl-module--seprateItem--3LYbt","alignRight":"feapnl-module--alignRight--2p6uZ"};